<template>
    <component
        :is="link ? 'router-link' : 'span'"
        v-if="company"
        :to="{ name: 'companies.show', params: { id: company.id } }"
        class="text-nowrap"
    >
        <i class="fa fa-building mr-2" />
        <span :class="{ 'text-decoration-line-through': company.archived_at }">
            {{ company.name }}
        </span>
    </component>
</template>

<script>
export default {
    props: {
        modelValue: [Object, String],
        rootvalue: Object,
        link: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        company () {
            if (this.rootvalue && typeof this.modelValue === 'string') {
                return this.rootvalue;
            }

            return this.modelValue;
        },
    },
};
</script>

<style lang="postcss" scoped>
.text-decoration-line-through {
    text-decoration: line-through;
}
</style>
